export default __webpack_public_path__ + "static/media/r6.065fcb71.jpg";